import { BlogPost } from '../types';

/**
 * Utility function to fetch blog posts from the public directory
 */
export const fetchBlogPosts = async (): Promise<BlogPost[]> => {
  try {
    const response = await fetch('/data/blogPosts.ts');
    const text = await response.text();
    
    // Extract the array from the TS file text
    // Support optional type annotation after the variable name, e.g.:
    // export const blogPosts: BlogPost[] = [ ... ];
    const arrayMatch = text.match(/export const blogPosts(?:\s*:\s*[^=]+)?\s*=\s*(\[[\s\S]*\]);/);
    if (arrayMatch && arrayMatch[1]) {
      // Use Function constructor to safely evaluate the array
      const postsArray: BlogPost[] = Function('return ' + arrayMatch[1])();
      const seenSlugs = new Set<string>();
      const uniquePosts = postsArray.filter((post) => {
        if (seenSlugs.has(post.slug)) {
          return false;
        }
        seenSlugs.add(post.slug);
        return true;
      });
      return uniquePosts.sort(
        (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
      );
    } else {
      console.error('Could not parse blogPosts array from file');
      return [];
    }
  } catch (error) {
    console.error('Error loading blog posts:', error);
    return [];
  }
}; 